import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Initialize Sentry for error tracking.
// Empty REACT_APP_SENTRY_DSN is intentional in non-prod / preview builds —
// keeps them off Sentry quota. Production sets the DSN via env at build
// time. If a preview accidentally gets the DSN, the environment tag below
// (NODE_ENV !== 'production' on dev builds) routes events away from prod.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1, // 10% of requests for performance
    replaysSessionSampleRate: 0.0, // Don't record sessions by default
    replaysOnErrorSampleRate: 1.0, // Record session on errors
    environment: process.env.NODE_ENV,
    release: "besume@5.25.18",
  });
  console.log("Sentry initialized for error tracking");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('SW registered:', reg.scope))
      .catch((err) => console.log('SW registration failed:', err));
  });
}
